//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectSelector.js";
let d=[[[0,"DrawingName",1,0],[0,"ExportData",1,0],[0,"ExportFrom",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"FacetBodies",1,0],[0,"IgesSettingsFile",1,0],[0,"InputFile",1,0],[0,"Jama",1,0],[0,"MaxLineThickness",1,0],[0,"MaxSystem3DModelSpace",1,0],[0,"MaxSystemPointRes",1,0],[0,"MaxUser3DModelSpace",1,0],[0,"MaxUserPointRes",1,0],[0,"Nxto2dSettingsFile",1,0],[0,"OutputFileType",1,0],[0,"OutputTo",1,0],[0,"OverlappingEntities",1,0],[0,"SpCurveTolerance",1,0],[0,"ViewName",1,0]],[[["filename"],"SaveNxto2dSettings",{},1,0],[["filename"],"SaveIgesSettings",{},1,0],[["objects"],"SetDrawingArray",{},1,0]],[]];
SPLM.NXTo2dCreator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.NXTo2dCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.NXTo2dCreator.ExportFromOption = Object.freeze({
    "DisplayPart" : "DisplayPart", "ExistingPart" : "ExistingPart"});

SPLM.NXTo2dCreator.OutputToOption = Object.freeze({
    "Modeling" : "Modeling", "Drafting" : "Drafting"});

SPLM.NXTo2dCreator.OutputAsOption = Object.freeze({
    "NXPartFile" : "NXPartFile", "IGESFile" : "IGESFile"});

SPLM.NXTo2dCreator.ExportDataOption = Object.freeze({
    "ModelData" : "ModelData", "Drawing" : "Drawing"});

export default SPLM;